const exitContextualSelection = canvasState => canvasState.merge({ contextualSelection: null });

export default exitContextualSelection;
